<template>
    <v-card>
        <v-toolbar class="darken-4" color="indigo" dark>
            <v-toolbar-title>
                {{$t('addreport')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn @click="dialogueClose" dark text>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <form>
                <v-row>
                    <v-col>
                        <v-text-field :error-messages="nameErrors"
                                      @blur="$v.formData.name.$touch()"
                                      @input="$v.formData.name.$touch()"
                                      :label="$t('reporttitle')"
                                      required dense outlined
                                      v-model="formData.name"></v-text-field>
                    </v-col>
                    <v-col>
                        <v-autocomplete :error-messages="reportIDsErrors"
                                        :items="listDatas"
                                        item-text="value"
                                        item-value="id"
                                        :label="$t('selectreportname')"
                                        required dense outlined
                                        chips
                                        v-model="formData.reportID">
                        </v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-autocomplete :error-messages="yearErrors"
                                        :items="yearList"
                                        item-text="id"
                                        item-value="value"
                                        :label="$t('selectyear')"
                                        required dense outlined
                                        v-model="formData.year">
                        </v-autocomplete>
                    </v-col>
                    <v-col>
                        <v-checkbox label="Show Accumulated Report"
                                    v-model="formData.isShowAccumulated"></v-checkbox>
                    </v-col>
                </v-row>


            </form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogueClose" color="red darken-1" dark>{{$t('cancel')}}</v-btn>
            <v-btn @click="formSubmit" class="custom-save-button" dark>{{$t('save')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: "SamikshyaReportForm",
        data() {
            return {
                yearList: [],
                formData: {
                    name:"",
                    reportID: "",
                    year:""
                },
                listDatas:[],
                message: {
                    status: true,
                    text: 'true',
                }
            }
        },
        computed: {
            nameErrors() {
                const errors = [];
                if (!this.$v.formData.name.$dirty) return errors;
                !this.$v.formData.name.required &&
                errors.push("Report title is required.");
                return errors;
            },
            reportIDErrors() {
                const errors = [];
                if (!this.$v.formData.reportID.$dirty) return errors;
                !this.$v.formData.reportID.required &&
                errors.push("Report is required.");
                return errors;
            },
            yearErrors() {
                const errors = [];
                if (!this.$v.formData.year.$dirty) return errors;
                !this.$v.formData.year.required &&
                errors.push("Year is required.");
                return errors;
            },
        },
        validations: {
            formData: {
                name: {required},
                reportID: {required},
                year: {required},
            }
        },
        mounted() {
            this.getFormData()
        },
        methods: {
            getFormData() {
                axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
                })
                axios.get('SamikshyaReport/DDLReportList').then(response => {
                    this.listDatas = response.data
                }).catch(err=>{
                    console.log(err)})
            },
            dialogueClose() {
                this.formData = {}
                this.$emit('dialogueClose')
            },
            formSubmit() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    axios.post('SamikshyaReport/Create', this.formData)
                        .then(() => {
                            this.message.status = true
                            this.message.text = 'Samikshya Report has been successfully created'
                            this.$emit('formResponse', this.message)
                            this.dialogueClose()
                        })
                        .catch(() => {
                            this.message.status = false
                            this.message.text = 'Error Adding Package, Please Contact Admin'
                        })
                }
            },
        }
    }
</script>

<style scoped>

</style>
